import { render, staticRenderFns } from "./home2.vue?vue&type=template&id=4e3422c0&scoped=true&"
import script from "./home2.vue?vue&type=script&lang=js&"
export * from "./home2.vue?vue&type=script&lang=js&"
import style0 from "./home2.vue?vue&type=style&index=0&id=4e3422c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3422c0",
  null
  
)

export default component.exports